import { useState } from "react";
import { motion } from "framer-motion";
import { MapPin, Trophy, ArrowUpRight, Building2 } from "lucide-react";
import { Link } from "react-router-dom";

const COUNTRIES = ["All Countries", "Australia", "Singapore", "Hong Kong", "Thailand", "Japan", "Indonesia"];
const LEVELS = ["All Levels", "Beginner", "Intermediate", "Competitive", "Masters"];
const FACILITIES = ["All Facilities", "Olympic Pool", "Open Water", "Indoor", "Outdoor"];

export function FindYourClub() {
  const [activeCountry, setActiveCountry] = useState("All Countries");
  const [activeLevel, setActiveLevel] = useState("All Levels");
  const [activeFacility, setActiveFacility] = useState("All Facilities");

  return (
    <section
      data-testid="find-club-section"
      className="bg-near-black py-24 md:py-32 relative overflow-hidden"
    >
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-amber-dusk/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 mb-16">
          <div>
            <p className="font-inter font-light text-xs tracking-[0.25em] uppercase text-solar-orange mb-3">
              Directory
            </p>
            <h2
              data-testid="clubs-section-title"
              className="font-inter font-semibold text-3xl md:text-4xl lg:text-5xl tracking-tighter text-white"
            >
              Find Your Club
            </h2>
          </div>
          <div className="flex items-end">
            <p className="font-inter font-normal text-base text-white/60 leading-relaxed max-w-md">
              Browse APAC swimming clubs, schools and academies plus upcoming competition meets. Whether you're a beginner or competing at elite level — sports for all.
            </p>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="space-y-6 mb-14"
        >
          {/* <div>
            <label className="font-inter font-light text-xs tracking-[0.15em] uppercase text-warm-gray mb-3 block">Country</label>
            <div className="flex flex-wrap gap-2" data-testid="filter-country">
              {COUNTRIES.map((c) => (
                <button
                  key={c}
                  onClick={() => setActiveCountry(c)}
                  data-testid={`filter-country-${c.toLowerCase().replace(/\s/g, '-')}`}
                  className={`font-inter font-medium text-xs px-4 py-2 rounded-sm border transition-colors duration-150 ${
                    activeCountry === c
                      ? "bg-solar-orange text-near-black border-solar-orange"
                      : "bg-transparent text-white/60 border-white/15 hover:border-white/30 hover:text-white"
                  }`}
                >{c}</button>
              ))}
            </div>
          </div>
          <div>
            <label className="font-inter font-light text-xs tracking-[0.15em] uppercase text-warm-gray mb-3 block">Level</label>
            <div className="flex flex-wrap gap-2" data-testid="filter-level">
              {LEVELS.map((l) => (
                <button
                  key={l}
                  onClick={() => setActiveLevel(l)}
                  data-testid={`filter-level-${l.toLowerCase().replace(/\s/g, '-')}`}
                  className={`font-inter font-medium text-xs px-4 py-2 rounded-sm border transition-colors duration-150 ${
                    activeLevel === l
                      ? "bg-solar-orange text-near-black border-solar-orange"
                      : "bg-transparent text-white/60 border-white/15 hover:border-white/30 hover:text-white"
                  }`}
                >{l}</button>
              ))}
            </div>
          </div>
          <div>
            <label className="font-inter font-light text-xs tracking-[0.15em] uppercase text-warm-gray mb-3 block">Facility</label>
            <div className="flex flex-wrap gap-2" data-testid="filter-facility">
              {FACILITIES.map((f) => (
                <button
                  key={f}
                  onClick={() => setActiveFacility(f)}
                  data-testid={`filter-facility-${f.toLowerCase().replace(/\s/g, '-')}`}
                  className={`font-inter font-medium text-xs px-4 py-2 rounded-sm border transition-colors duration-150 ${
                    activeFacility === f
                      ? "bg-solar-orange text-near-black border-solar-orange"
                      : "bg-transparent text-white/60 border-white/15 hover:border-white/30 hover:text-white"
                  }`}
                >{f}</button>
              ))}
            </div>
          </div> */}
        </motion.div>

        {/* <div className="border-t border-white/10 mb-14" /> */}

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.15 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          <Link
            to="/clubs"
            data-testid="clubs-directory-cta"
            className="group border border-white/10 rounded-sm p-8 md:p-10 hover:border-solar-orange/40 transition-colors duration-200 block"
          >
            <div className="flex items-center gap-4 mb-4">
              <div className="bg-solar-orange/10 p-3 rounded-sm"><Building2 size={24} className="text-solar-orange" /></div>
              <h3 className="font-inter font-semibold text-xl text-white group-hover:text-solar-orange transition-colors duration-150">Clubs Directory</h3>
            </div>
            <p className="font-inter font-normal text-sm text-white/50 leading-relaxed mb-6">Find swimming clubs, schools, and academies across Asia Pacific. Filter by country, level, and facilities.</p>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2 text-warm-gray"><MapPin size={14} /><span className="font-inter font-light text-xs">7 Countries</span></div>
              <div className="flex items-center gap-2 text-warm-gray"><Building2 size={14} /><span className="font-inter font-light text-xs">200+ Clubs</span></div>
            </div>
            <span className="inline-flex items-center gap-1 font-inter font-medium text-sm text-solar-orange mt-6 group-hover:gap-2 transition-all duration-150">Browse Clubs<ArrowUpRight size={14} /></span>
          </Link>

          <Link
            to="/meets"
            data-testid="competition-meets-cta"
            className="group border border-white/10 rounded-sm p-8 md:p-10 hover:border-solar-orange/40 transition-colors duration-200 block"
          >
            <div className="flex items-center gap-4 mb-4">
              <div className="bg-solar-orange/10 p-3 rounded-sm"><Trophy size={24} className="text-solar-orange" /></div>
              <h3 className="font-inter font-semibold text-xl text-white group-hover:text-solar-orange transition-colors duration-150">Competition Meets</h3>
            </div>
            <p className="font-inter font-normal text-sm text-white/50 leading-relaxed mb-6">Upcoming swim meets and competitions across the APAC region. Stay informed and plan your competitive calendar.</p>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2 text-warm-gray"><Trophy size={14} /><span className="font-inter font-light text-xs">50+ Events</span></div>
              <div className="flex items-center gap-2 text-warm-gray"><MapPin size={14} /><span className="font-inter font-light text-xs">APAC Wide</span></div>
            </div>
            <span className="inline-flex items-center gap-1 font-inter font-medium text-sm text-solar-orange mt-6 group-hover:gap-2 transition-all duration-150">View Meets<ArrowUpRight size={14} /></span>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
